const UPDATE_CHART_SETTINGS = 'UPDATE_CHART_SETTINGS';
const CREATE_NEW_EXERCISES = 'CREATE_NEW_EXERCISES';
const CREATE_ANSWER_ATTEMPT = 'CREATE_ANSWER_ATTEMPT';

export { UPDATE_CHART_SETTINGS, CREATE_NEW_EXERCISES, CREATE_ANSWER_ATTEMPT };
